export const ROOT = '/';
export const CASACERRADA = '/casa-cerrada';
export const GRUPO_SAESA_WEB_URL = 'https://web.gruposaesa.cl/';
